<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>Projekte</h3>
</div>

<div class="row filter-row mb-3" *ngIf="stats">
    <div class="col">
        <div class="card card-stats">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <p (click)="setFilterStatus(['CREATED'])" class="bg-dark"><span>{{ stats.created }}</span> Ideen</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['RELEASED','IN_PROGRESS'])" class="bg-info"><span>{{ stats.in_progress + stats.released }}</span> Projekte</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['IN_ELABORATION','EVALUATION','REVISE'])" class="bg-danger"><span>{{ stats.in_elaboration + stats.evaluation + stats.revise }}</span> Offene Projektaufträge</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['COMPLETION_FILED'])" class="bg-warning text-dark" style="background: #ffff08;"><span>{{ stats.completion_filed }}</span> Eingereichte Projektabschlüsse</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <h5 class="card-header">
        {{ totalProjects }} Projekte
        <button type="button" class="btn btn-primary btn-sm ms-1" [routerLink]="['/project/detail', 0]"><i class="fas fa-plus"></i> Neue Idee</button>

        <pagination class="float-end mb-0" style="font-size: 1rem"
                    [hidden]="projects.length === 0"
                    [totalItems]="totalProjects"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="loadProjects($event)"
                    [maxSize]="10"
                    previousText="Zurück"
                    nextText="Weiter"
        />
        <button type="button" class="btn btn-secondary btn-sm float-end me-2" (click)="resetFilterAndReload()">Filter zurücksetzen</button>
        <button type="button" class="btn btn-secondary btn-sm float-end me-2"
                [disabled]="exporting || totalProjects === 0"
                (click)="exportProjects()">Export Excel
        </button>
        <div class="form-check float-end me-2" style="font-size: 0.875rem; position: relative; top: 5px">
            <input class="form-check-input" type="checkbox" [(ngModel)]="filter.showPast" (ngModelChange)="loadProjects(paginConfig)">
            <label class="form-check-label fw-normal">
                Nur laufende Projekte anzeigen
            </label>
        </div>
    </h5>
    <div class="card-body">

        <div class="table-responsive">
            <table class="table table-hover table-striped table-sm table-new mb-0">
                <thead>
                <tr>
                    <th>
                        <input type="text" class="form-control form-control-sm" name="number" appDebounceKeyup (debounceKeyup)="loadProjects(paginConfig)" [(ngModel)]="filter.number" [class.is-filtered]="filter.number !== ''">
                    </th>
                    <th></th>
                    <th>
                        <button type="button" class="btn btn-secondary btn-sm" style="width: 100%"
                                [class.is-filtered]="filter.status.length > 0"
                                [popover]="popTemplate"
                                [outsideClick]="true" popoverTitle="Auswahl Status">
                            {{filter.status.length}} Filter aktiv
                        </button>
                    </th>
                    <th>
                        <input type="text" class="form-control form-control-sm" name="title" appDebounceKeyup (debounceKeyup)="loadProjects(paginConfig)" [(ngModel)]="filter.title" [class.is-filtered]="filter.title !== ''">
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_region" [(ngModel)]="filter.id_region" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_region !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let region of regions" [value]="region.id">Region {{ region.region }} ({{ region.countries }})</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_country" [(ngModel)]="filter.id_country" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_country !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let country of countries" [value]="country.short">{{ country.short }}</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_lead" [(ngModel)]="filter.id_lead" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_lead !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let lead of leads" [value]="lead.id">{{ lead.short }}</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_department" [(ngModel)]="filter.id_department" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_department !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let department of departments" [value]="department.id">{{ department.name }} ({{ department.lead }})</option>
                        </select>
                    </th>
                    <th colspan="2"></th>
                    <th>
                        <select class="form-control form-control-sm" name="content" [(ngModel)]="filter.content" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.content !== 'all'">
                            <option value="all">Alle</option>
                            <option value="success">Im Plan</option>
                            <option value="warning">Leichte Veränderung</option>
                            <option value="danger">Handlungsbedarf</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="time" [(ngModel)]="filter.time" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.time !== 'all'">
                            <option value="all">Alle</option>
                            <option value="success">Im Plan</option>
                            <option value="warning">Leichte Veränderung</option>
                            <option value="danger">Handlungsbedarf</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="costs" [(ngModel)]="filter.costs" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.costs !== 'all'">
                            <option value="all">Alle</option>
                            <option value="success">Im Plan</option>
                            <option value="warning">Leichte Veränderung</option>
                            <option value="danger">Handlungsbedarf</option>
                        </select>
                    </th>
                    <th></th>
                    <th>
                        <select class="form-control form-control-sm" name="milestones" [(ngModel)]="filter.milestones" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.milestones !== 'all'">
                            <option value="all">Alle</option>
                            <option value="fully">Erfüllt</option>
                            <option value="partial">Teilweise erfüllt</option>
                            <option value="none">Nicht erfüllt</option>
                        </select>
                    </th>
                </tr>
                <!--<tr>
                    <th>
                        <select class="form-control form-control-sm" style="width: 20px" name="status" [(ngModel)]="filter.light_time" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.light_time !== 'all'">
                            <option value="all">{{'GENERAL.ALL' | translate}}</option>
                            <option *ngFor="let light of lightList" [ngValue]="light">{{ ('STATUS.' + light.toUpperCase()) | translate }}</option>
                        </select>
                    </th>

                </tr>-->
                <tr>
                    <th (click)="setOrder('number')">
                        Nummer <i *ngIf="filter.order === 'number'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th (click)="setOrder('start')" style="min-width: 105px">
                        Projektstart <i *ngIf="filter.order === 'start'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th class="no-pointer">Status</th>
                    <th class="no-pointer">Titel</th>
                    <th (click)="setOrder('id_region')" style="min-width: 50px">
                        Länderbereich <i *ngIf="filter.order === 'id_region'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th class="no-pointer" style="min-width: 50px">
                        Länder <i *ngIf="filter.order === 'country'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th (click)="setOrder('lead')">
                        Projektleiter <i *ngIf="filter.order === 'lead'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th (click)="setOrder('id_department')">
                        Abteilung <i *ngIf="filter.order === 'id_department'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th class="no-pointer">Freigabe</th>
                    <th class="no-pointer">Anlage</th>
                    <th class="no-pointer">Inhalt</th>
                    <th class="no-pointer">Zeit</th>
                    <th class="no-pointer">Kosten</th>
                    <th (click)="setOrder('last_statusreport')">
                        Letztes Statusupdate <i *ngIf="filter.order === 'last_statusreport'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i>
                    </th>
                    <th class="no-pointer">Meilensteine</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let project of projects" [class.is-highlighted]="project.id === highlightedRow" (click)="highlightRow(project.id)" [routerLink]="['/project/detail', project.id]">
                    <td>{{ project.number }}</td>
                    <td>{{ project.start | date: 'dd.MM.yyyy' }}</td>
                    <td>{{ project.status | projectStatus }}</td>
                    <td>{{ project.title_project ? project.title_project : project.title }}</td>
                    <td>{{ project.region }}</td>
                    <td>{{ project.countries }}</td>
                    <td>{{ project.lead }}</td>
                    <td>{{ project.department }}</td>
                    <td>
                        <i class="fa-solid fa-circle"
                           *ngIf="project.approvalsProject.length > 0"
                           [ngClass]="{'text-success': project.approvalProjectStatus === 'success', 'text-warning': project.approvalProjectStatus === 'warning', 'text-danger': project.approvalProjectStatus === 'danger'}">
                        </i>
                    </td>
                    <td>
                      <i class="fa-solid fa-circle"
                         [ngClass]="{'text-success': project.externalStatus === 'success', 'text-warning': project.externalStatus === 'warning', 'text-danger': project.externalStatus === 'danger'}">
                      </i>
                    </td>
                    <td>
                        <i class="fa-solid fa-circle"
                           *ngIf="project.status_report"
                           [ngClass]="{'text-success': project.status_report?.content === 'success', 'text-warning': project.status_report?.content === 'warning', 'text-danger': project.status_report?.content === 'danger'}">
                        </i>
                    </td>
                    <td>
                        <i class="fa-solid fa-circle"
                           *ngIf="project.status_report"
                           [ngClass]="{'text-success': project.status_report?.time === 'success', 'text-warning': project.status_report?.time === 'warning', 'text-danger': project.status_report?.time === 'danger'}">
                        </i>
                    </td>
                    <td>
                        <i class="fa-solid fa-circle"
                           *ngIf="project.status_report"
                           [ngClass]="{'text-success': project.status_report?.costs === 'success', 'text-warning': project.status_report?.costs === 'warning', 'text-danger': project.status_report?.costs === 'danger'}">
                        </i>
                    </td>
                    <td [class.bg-danger]="project.status_missing" [class.text-white]="project.status_missing">{{ project.status_report?.created_at | date: 'dd.MM.yyyy' }}</td>
                    <td>{{ project.milestonesCompleted }}/{{ project.milestones.length }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #popTemplate>
    <select class="form-control form-control-sm" name="status" size="11" multiple [(ngModel)]="filter.status" (ngModelChange)="loadProjects(paginConfig)">
        <option *ngFor="let status of ProjectStatus | keyvalue: asIsOrder" [value]="status.key">{{ status.value | projectStatus }}</option>
    </select>
</ng-template>
